import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=0063517f&scoped=true&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063517f",
  null
  
)

export default component.exports